import { render, staticRenderFns } from "./LargeImage.vue?vue&type=template&id=00fd58bc&name=large-image&"
import script from "./LargeImage.vue?vue&type=script&lang=js&"
export * from "./LargeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports